import getWithToken from './base/get-with-token'

const getListAnzsicCode = getWithToken(`/list-anzsic-code`)

export default getListAnzsicCode